"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _program = require("@studio/program");
var _actionUtils = require("../../../utils/actionUtils");
var _setSceneLayoutRealtime = _interopRequireDefault(require("../../../actions/program/setSceneLayoutRealtime"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function sceneLayoutChanged(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var notifyingDirector = _ref2.notifyingDirector,
    layout = _ref2.layout;
  var state = getState();
  var sceneLayout = state.sceneLayout;
  if (!(0, _actionUtils.isSameAttendee)(notifyingDirector, state)) {
    // if the layout has changed we sync it to the new value
    if (!(0, _program.isLayout)(sceneLayout, layout)) {
      dispatch((0, _setSceneLayoutRealtime["default"])(layout));
    }
  }
}
var _default = exports["default"] = sceneLayoutChanged;